// Sonidos y voz amable para la estación de registro

let _ctx;
const ctx = () => {
  if (typeof window === "undefined") return null;
  if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
};

function tone(freq, start, dur, gain = 0.18, type = "sine") {
  const ac = ctx();
  if (!ac) return;
  const t0 = ac.currentTime + start;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.03);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g);
  g.connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

// Campanita ascendente y clara (éxito) — más presente para que se note desde lejos
export function playSuccessChime() {
  try {
    tone(659.25, 0, 0.16, 0.32);      // Mi5
    tone(987.77, 0.12, 0.20, 0.30);   // Si5
    tone(1318.5, 0.26, 0.30, 0.28);   // Mi6
  } catch { /* noop */ }
}

// Tono grave doble (rechazo) — con cuerpo para que se escuche
export function playRejectBuzz() {
  try { tone(220, 0, 0.22, 0.30, "square"); tone(150, 0.18, 0.34, 0.28, "square"); } catch { /* noop */ }
}

// Vibración del dispositivo (Android/tablets; iOS Safari lo ignora sin error)
function buzz(pattern) {
  try { if (navigator && typeof navigator.vibrate === "function") navigator.vibrate(pattern); } catch { /* noop */ }
}

// Alerta suave y cálida (nueva solicitud de salida). Mezcla mullida, poco intrusiva.
export function playSoftAlert() {
  try {
    tone(783.99, 0, 0.22, 0.10, "sine");     // Sol5
    tone(1046.5, 0.16, 0.34, 0.085, "sine");  // Do6
  } catch { /* noop */ }
}

// "Pop" corto para mensajes de chat entrante.
export function playPop() {
  try {
    const ac = ctx();
    if (!ac) return;
    const t0 = ac.currentTime;
    const osc = ac.createOscillator();
    const g = ac.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(420, t0);
    osc.frequency.exponentialRampToValueAtTime(900, t0 + 0.06);
    osc.frequency.exponentialRampToValueAtTime(520, t0 + 0.14);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(0.16, t0 + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.18);
    osc.connect(g);
    g.connect(ac.destination);
    osc.start(t0);
    osc.stop(t0 + 0.2);
  } catch { /* noop */ }
}

// --- Voz (Web Speech API) ---
let _voices = [];
function loadVoices() {
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  _voices = window.speechSynthesis.getVoices() || [];
}
if (typeof window !== "undefined" && window.speechSynthesis) {
  loadVoices();
  window.speechSynthesis.onvoiceschanged = loadVoices;
}

// Desbloqueo de audio/voz: navegadores de escritorio (Chrome/Safari) exigen un
// gesto del usuario antes de reproducir audio o voz. Tras la primera interacción
// en cualquier parte de la app, reanudamos el AudioContext y "calentamos" la voz
// para que el saludo de la Estación NFC funcione también en computadora.
function unlockAudioOnce() {
  try { ctx(); } catch { /* noop */ }
  try {
    if (window.speechSynthesis) {
      const warm = new SpeechSynthesisUtterance(" ");
      warm.volume = 0;
      window.speechSynthesis.speak(warm);
      loadVoices();
    }
  } catch { /* noop */ }
  window.removeEventListener("pointerdown", unlockAudioOnce);
  window.removeEventListener("keydown", unlockAudioOnce);
  window.removeEventListener("touchstart", unlockAudioOnce);
}
if (typeof window !== "undefined") {
  window.addEventListener("pointerdown", unlockAudioOnce);
  window.addEventListener("keydown", unlockAudioOnce);
  window.addEventListener("touchstart", unlockAudioOnce);
}

function pickSpanishVoice() {
  if (!_voices.length) loadVoices();
  const pref = [
    /Paulina/i, /M[oó]nica/i, /Google espa/i, /Helena/i, /Laura/i, /Sabina/i,
  ];
  for (const re of pref) {
    const v = _voices.find((x) => re.test(x.name));
    if (v) return v;
  }
  return _voices.find((x) => /es[-_]MX/i.test(x.lang))
    || _voices.find((x) => /es[-_]US/i.test(x.lang))
    || _voices.find((x) => /^es/i.test(x.lang))
    || null;
}

export function speak(text) {
  try {
    if (typeof window === "undefined" || !window.speechSynthesis) return;
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "es-MX";
    u.rate = 0.96;   // un poco pausada
    u.pitch = 1.15;  // tono cálido
    u.volume = 1;
    const v = pickSpanishVoice();
    if (v) u.voice = v;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(u);
  } catch { /* noop */ }
}

const firstName = (full) => (full || "").trim().split(/\s+/)[0] || "";

// Saludo amable según tipo (in/out)
export function announceAttendance(fullName, type) {
  // Solo sonido de confirmación + vibración. La voz hablada fue desactivada a petición del colegio.
  playSuccessChime();
  buzz(180);
}

export function announceReject() {
  playRejectBuzz();
  buzz([120, 70, 120]);
}
